export default "__VITE_ASSET__fdeb3618__"